import PropTypes from 'prop-types';
// material
import Typography from '@mui/material/Typography';
import { grey, green } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
// helper
import { numberFormat } from '../../../../helpers/Util';

const PriceMutedStyle = styled(Typography)(() => ({
  color: grey[400],
  textDecoration: 'line-through',
  marginRight: '5px'
}));

const PriceStyle = styled(Typography)(() => ({
  color: green[800]
}));

ItemPrice.propTypes = {
  ticket: PropTypes.object
};

export default function ItemPrice({ ticket }) {
  if (!ticket.voucher.isApplicable) {
    return <PriceStyle component="span">{numberFormat(ticket.price.withDiscount)}</PriceStyle>;
  }

  if (ticket.isValid === true) {
    return (
      <>
        <PriceMutedStyle component="span">{numberFormat(ticket.price.original)}</PriceMutedStyle>
        <PriceStyle component="span">{numberFormat(ticket.price.withDiscount)}</PriceStyle>
      </>
    );
  }

  return <PriceStyle component="span">{numberFormat(ticket.price.original)}</PriceStyle>;
}
